import { Box } from '@locus-taxy/encore-mui';
import LoadingSpinner from './LoadingSpinner';

interface SuspenseLoaderProps {
  message?: string;
}

const SuspenseLoader = ({ message }: SuspenseLoaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <LoadingSpinner showRandomMessage={false} message={message} />
    </Box>
  );
};

export default SuspenseLoader;
